import { BookingLaunchContext, VoucherLaunchContext } from './landing-page-launch.types'
import { BookingModalComponent } from '../../booking-modal/booking-modal.component'
import { Injectable } from '@angular/core'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { VoucherModalComponent } from '../../voucher-modal/voucher-modal.component'

@Injectable({
    providedIn: 'root',
})
export class LandingPageModalService {

    constructor(
        private modalService: NgbModal
    ) { }

    openBookingModal(context: BookingLaunchContext): NgbModalRef {
        const modal = this.modalService.open(BookingModalComponent, {
            backdrop: 'static',
            backdropClass: 'booking-modal-backdrop',
            fullscreen: 'sm',
            keyboard: false,
            modalDialogClass: 'modal-dialog-centered modal-centered-optical',
            scrollable: true,
            size: 'lg',
            windowClass: 'booking-modal-window booking-modal-window-with-footer',
        })
        const component = modal.componentInstance as BookingModalComponent
        component.configureForNgbModal(context)
        return modal
    }

    openVoucherModal(context: VoucherLaunchContext): NgbModalRef {
        const modal = this.modalService.open(VoucherModalComponent, {
            backdrop: 'static',
            fullscreen: 'md',
            keyboard: false,
            modalDialogClass: 'modal-dialog-centered modal-fluid-until-md modal-centered-optical',
            scrollable: true,
            size: 'xl',
            windowClass: 'booking-modal-window',
        })
        const component = modal.componentInstance as VoucherModalComponent
        component.configureForNgbModal(context)
        return modal
    }
}
